:host {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.content,
.content-cve {
  overflow-x: hidden;
  overflow-y: auto;
}

.section {
  margin-right: calc(var(--spacer) * 2 - 4px);

  &:not(:last-child) {
    border-bottom: 1px solid var(--chart-101-pressed-dividers);
  }
}

.group-buttons > * {
  &:not(:last-child) {
    padding-right: var(--spacer);
  }
}

.section-title {
  color: var(--chart-300-icon-buttons);
  font-weight: 500;
}

gz-labeled-content::part(label) {
  color: var(--chart-300-icon-buttons);
}

.text-description {
  line-height: 1.5;
}

gz-labeled-content::part(content),
.text-description {
  color: var(--main-titles-inputs-600);
}

gz-labeled-content::part(content) {
  font-size: var(--body-size);
}

.header {
  gz-title {
    color: var(--body-text-arrows-400);
    font-weight: 500;
  }
}

.accordion-title {
  font-size: var(--body-size);
  color: var(--chart-300-icon-buttons);
}

.separator {
  border-left: 1px solid var(--chart-101-pressed-dividers);
  padding-left: var(--spacer);
  margin-left: var(--spacer);
}

.link-container {
  gz-link {
    &::part(container) {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

gz-tab {
  position: static;
}

gz-tab-group {
  height: auto;
}

.min-width-zero {
  min-width: 0;
}

.indicator-status {
  color: var(--chart-300-icon-buttons);
}

gz-icon-label {
  pointer-events: none;
}

.sction {
  &.no-border {
    border-bottom: none;
  }
}

gz-button[class*='backBtn'] {
  margin-top: calc(var(--spacer) - 2px);

  &::part(button-text) {
    height: 100%;
  }
}

gz-icon[class*='backBtn-icon'] {
  margin-left: -10px;
}

.severity-high {
  &:before {
    background-color: var(--red-alert-500-severe);
  }
}

.severity-medium {
  &:before {
    background-color: var(--orange-alert-chart-100);
  }
}

.severity-low {
  &:before {
    background-color: var(--yellow-alert-050);
  }
}

.severity-compliant {
  &:before {
    background-color: var(--green-pastel-alert-chart-050-healty);
  }
}

.severity-none {
  &:before {
    background-color: var(--chart-300-icon-buttons);
  }
}

.show-more-button {
  padding-top: calc(var(--spacer) / 2 - 1px);
  padding-left: var(--spacer);
}
